<template>
  <b-modal
    :hide-footer="true"
    title="Solicitação de vaga"
    centered
    size="lg"
    id="solicitacao-vagas"
    :visible="false"
    :no-close-on-backdrop="true"
    :tabindex="0"
  >
    <div>
      <div class="row">
        <div class="col-lg-12">
          <fieldset>
            <legend class="small text text-info">Detalhes da solicitação  </legend> 
            <div class="row">
              <div class="col-lg-12">
                <form-select
                  label="Público"
                  :itens="$root.arrays.acolhimento_publico_alvo"
                  v-model="data.publico_alvo_id"
                  :required="true"
                />
                <form-input
                  type="text"
                  v-model="data.desc_publico_alvo"
                  label="Descrição Público-Alvo"
                  v-show="mostrarDescricao"
                  :required="mostrarDescricao"
                />
              </div>

              <div class="col-lg-6">
                <form-select label="Origem da Solicitação" :itens="$root.arrays.acolhimento_origem_solicitacao" v-model="data.origem_solicitacao_id" :required="true" />
                <template v-if="this.municipio == 'guarulhos'">
                  <form-select label="Unidade Solicitante" :itens="$root.arrays.unidade_solicitante_guarulhos" v-model="data.unidade_solicitante" :required="true" />
                </template>
                <template v-else>
                  <form-select label="Unidade Solicitante" :itens="unidades" v-model="data.unidade_solicitante" :required="true" />
                </template>
              </div>

              <div class="col-lg-6">
                <form-input label="Data da solicitação pela unidade de origem" type="date" v-model="data.data_solicitacao" :required="true" />
                <form-select label="Serviço socioassistencial" :itens="servicos" v-model="data.servico_socioassistencial_id"/>
              </div>

              <div class="col-lg-12">
                <form-input
                  type="text"
                  v-model="data.desc_origem_solicitacao"
                  label="Descrição da Origem da Solicitação"
                  v-show="mostrarDescricaoOrigemSolicitacao"
                  :required="mostrarDescricaoOrigemSolicitacao"
                />
              </div>

              <div class="col-lg-12" v-show="mostrarDescricaoOutroServico"> 
                <form-input type="text" label="Descreva o serviço socioassistencial" v-model="data.desc_servico_socioassistencial" :required="mostrarDescricaoOutroServico" />
              </div>

              <div class="col-lg-6">
                <form-input label="Nome do(a) responsável pela solicitação" v-model="data.resp_solicitacao" :required="true" />
              </div>

              <div class="col-lg-6">
                <form-select v-model="data.role_id" :itens="roles" :required="true" placeholder="Selecione uma Função" label="Função da Unidade" />
              </div>

            </div>
          </fieldset>
        </div>

        <div class="col-lg-12">
          <fieldset>
            <legend class="small text text-info">Detalhes do usuário</legend>
            <div class="row">
              <div class="col-lg-6">
                <form-input label="Nome completo do usuário" v-model="data.nome_usuario" :required="true" />
                <form-input label="Data de nascimento" v-model="data.nascimento" type="date" />
              </div>
              <div class="col-lg-6">
                <form-input label="Nome social" v-model="data.nome_social" />
                <form-input label="Número do CPF" v-model="data.cpf" v-mask="'###.###.###-##'"/>
              </div>
              <div class="col-lg-3"> 
                <form-select label="Sexo" :itens="$root.arrays.sexo" v-model="data.sexo_id" :required="true"/>
              </div>
              <div class="col-lg-3"> 
                <form-select label="Gênero" :itens="genero" v-model="data.genero_id" :required="true"/>
              </div>
              <div class="col-lg-12">
                <form-input
                  type="text"
                  v-model="data.desc_genero"
                  label="Descreva o Gênero"
                  v-show="mostrarDescricaoGenero"
                  :required="mostrarDescricaoGenero"
                />
              </div>
              <div class="col-lg-6"> 
                <form-select label="Pessoa com deficiência?" :itens="pergunta" v-model="data.deficiencia" :required="false" />
              </div>
              <div class="col-lg-6"> 
                <form-select label="Tipo de Deficiência" :itens="$root.arrays.tipo_deficiencia" v-model="data.list_deficiencia" v-show="mostrarDeficiencia" :required="mostrarDeficiencia" :multiple="true"/>
              </div>
              <div class="col-lg-12"> 
                <form-select label="Em função da deficiência, requer apoio para atividades de vida diária?" :itens="pergunta" v-model="data.deficiencia_requer_apoio" v-show="mostrarDeficiencia" :required="mostrarDeficiencia"/>
              </div>
              <div class="col-lg-12"> 
                <form-input label="Descreva a Deficiência" v-model="data.tipo_deficiencia" v-show="mostrarDescDeficiencia" :required="mostrarDescDeficiencia"/>
              </div>
              <div class="col-lg-6"> 
                <form-select label="Pessoa em situação de rua?" :itens="pergunta" v-model="data.situacao_rua" :required="true"/>
                <form-select label="Quantidade e nome de irmãos" :itens="pergunta" v-model="data.grupo_irmaos" :required="true"/>
              </div>
              <div class="col-lg-6"> 
                <form-select label="Família com presença de criança(s) e/ou adolescente(s)?" :itens="$root.arrays.membros_na_familia" v-model="data.familia_membros" :required="true" :multiple="true"/>
                <form-input label="Termo Acolhimento" v-model="data.termo_acolhimento"/>
              </div>

              <div class="col-lg-12" v-show="mostrarNumeroIrmaos"> 
                <form-input label="Informe o número de irmãos:" :itens="pergunta" v-model="data.numero_irmaos" :required="mostrarNumeroIrmaos"/>
              </div>

              <!-- Campos que aparecem dinamicamente -->
              <div v-for="(irmao, index) in data.nome_irmaos" :key="index" class="col-lg-12">
                <form-input
                  :label="`Nome do Irmão ${index + 1}`"
                  v-model="irmao.nome"
                  required
                />
              </div>

              <div class="col-lg-12" v-if="mostrarCampoGrauDependencia"> 
                <form-select label="Grau de dependência (RDC ANVISA 283/2005)" :itens="dependencia" v-model="data.grau_dependencia_id" :required="false"/>
              </div>

              <div class="col-lg-12">
                <form-select label="Motivo(s) do Acolhimento:" :itens="$root.arrays.motivos_acolhimento" v-model="data.motivo_acolhimento" :required="false" :multiple="true"/>
              </div>

              <div class="col-lg-12">
                <form-input type="text" v-model="data.desc_motivo_acolhimento" label="Descreva o Motivo(s) do Acolhimento:" v-show="mostrarMotivoAcolhimento" :required="mostrarMotivoAcolhimento"/>
              </div>
              
              <div class="col-lg-12">
                <form-file @submit="submitFile" multiple btn-text="Iniciar" :progress="progressCompleted" />
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="row">
        <hr />
      </div>

      <button @click="submit" class="btn btn-success btn-submit">
        <i class="fas fa-check" />
        {{ modo === 'editar' ? 'Salvar alterações' : 'Solicitar vaga' }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
    props: {
      item: Object,
      modo: {
        type: String,
        default: 'criar' // ou 'editar'
      }
    },
    data() {
      return {
        modo: this.modo,
        loading: false,
        municipio: "",
        violacoes: [],
        unidades: [],
        servicos: [],
        roles: [],
        data: {
          desc_publico_alvo: '',
          desc_motivo_acolhimento: '',
          desc_servico_socioassistencial: '',
          numero_irmaos: 0,
          nome_irmaos: []
        },
        files: {},
        raca: this.$root.arrays.cor_raca,
        genero: this.$root.arrays.genero,
        profissao: this.$root.arrays.profissao_principal,
        programa: this.$root.arrays.programas,
        dependencia: this.$root.arrays.acolhimento_grau_dependencia,
        pergunta: this.$root.arrays.pergunta
    };
  },
  mounted() {
    this.$root.$on('abrirModalVaga', ({ modo, item }) => {
      this.modo = modo;
      this.data = {};
      if (modo === 'editar') {
        this.data = { ...item };
        // Ajustar os campos booleanos para os valores 1 ou 2
        this.data.deficiencia = item.deficiencia ? 1 : 2;
        this.data.sexo_id = item.sexo_id ? 1 : 2;
        this.data.deficiencia_requer_apoio = item.deficiencia_requer_apoio ? 1 : 2;
        this.data.situacao_rua = item.situacao_rua ? 1 : 2;
        this.data.grupo_irmaos = item.grupo_irmaos ? 1 : 2;
        
        if (item.motivo_acolhimento && Array.isArray(item.motivo_acolhimento)) {
            this.data.motivo_acolhimento = item.motivo_acolhimento.map(id =>
                parseInt(id)
            );
        } else {
            this.data.motivo_acolhimento = [];
        }

        // Se nome_irmaos vier como string JSON, parseia
        if (typeof this.data.nome_irmaos === "string") {
          try {
            this.data.nome_irmaos = JSON.parse(this.data.nome_irmaos);
          } catch (e) {
            this.data.nome_irmaos = [];
          }
        }

        // Ajusta a quantidade com base na lista já salva
        this.data.numero_irmaos = this.data.nome_irmaos.length;

      }
      this.$bvModal.show('solicitacao-vagas');
    });

    this.getViolacoes();
    this.getServicos();
    this.getRoles();
    this.getUnidades();
    this.buscarMunicipio();

    this.data.unidade_id = this.item.unidade.id;
  },
  watch: {
    'data.publico_alvo_id'(valor) {
      if (valor !== 35 && (!valor?.id || valor.id !== 35)) {
        this.data.desc_publico_alvo = '';
      }
    },
    'data.origem_solicitacao_id'(valor) {
      if (valor !== 17 && (!valor?.id || valor.id !== 17)) {
        this.data.desc_origem_solicitacao = '';
      }
    },
    'data.genero_id'(valor) {
      if (valor !== 6 && (!valor?.id || valor.id !== 6)) {
        this.data.desc_genero = '';
      }
    },
    'data.numero_irmaos'(novaQtd) { 
      novaQtd = Number(novaQtd) || 0;  
  
      // Se a quantidade for igual ao que já existe, não faz nada
      if (novaQtd === this.data.nome_irmaos.length) return;

      if (novaQtd > this.data.nome_irmaos.length) {
        for (let i = this.data.nome_irmaos.length; i < novaQtd; i++) {
          this.data.nome_irmaos.push({ nome: "" });
        }
      } else if (novaQtd < this.data.nome_irmaos.length) {
        this.data.nome_irmaos.splice(novaQtd);
      }
    },
    'data.deficiencia'(valor) {
      if (valor !== 1) {
        this.data.list_deficiencia = [];
        this.data.desc_deficiencia = '';
        this.data.deficiencia_requer_apoio = '';
      }
    },
    'data.list_deficiencia'(novosValores) {
      if (!novosValores?.some(opcao => opcao === "7" || opcao.id === "7")) {
          this.data.tipo_deficiencia = '';
      }
    },
    'data.grupo_irmaos'(valor) {
        if (valor !== 1 && (!valor?.id || valor.id !== 1)) {
            this.data.numero_irmaos = '';
        }
    },
    'data.motivo_acolhimento'(novosValores) {
        // Se a opção 19 não estiver selecionada, limpa o campo de descrição
        if (!novosValores?.some(opcao => opcao === 19 || opcao.id === 19)) {
            this.data.desc_motivo_acolhimento = '';
        }
    },
    'data.servico_socioassistencial_id'(val) {
      const selecionado = this.servicos.find(s => s.id === val);
      if (!selecionado || selecionado.value?.toUpperCase() !== 'OUTROS') {
        this.data.desc_servico_socioassistencial = '';
      }
    }
  },
  computed: {
    mostrarDescricao() {
      const publico = this.data.publico_alvo_id;
      return publico === 35 || (publico?.id === 35);
    },
    mostrarDescricaoOrigemSolicitacao() {
      const origem_solicitacao = this.data.origem_solicitacao_id;
      return origem_solicitacao === 17 || (origem_solicitacao?.id === 17);
    },
    mostrarDescricaoGenero() {
      const genero = this.data.genero_id;
      return genero === 6 || (genero?.id === 6);
    },
    mostrarDeficiencia() {
      const deficiencia = this.data.deficiencia;
      return deficiencia === 1 || (deficiencia?.id === 1);
    },
    mostrarDescDeficiencia(){
      return this.data.list_deficiencia?.some(opcao => opcao === "7" || opcao.id === "7");
    },
    mostrarNumeroIrmaos() {
        const grupo = this.data.grupo_irmaos;
        return grupo === 1 || (grupo?.id === 1);
    },
    mostrarMotivoAcolhimento() {
        return this.data.motivo_acolhimento?.some(opcao => opcao === 19 || opcao.id === 19);
    },
    mostrarDescricaoOutroServico() {
      // Pode ser um número fixo (id da opção "OUTROS") ou comparar pelo texto
      const selecionado = this.servicos.find(s => s.id === this.data.servico_socioassistencial_id);

      return selecionado && (
        selecionado.value?.toUpperCase() === 'OUTROS' ||
        selecionado.descricao?.toUpperCase() === 'OUTROS'
      );
    },
    idadeUsuario() {
      if (!this.data.nascimento) return null;
      const hoje = new Date();
      const nascimento = new Date(this.data.nascimento);
      let idade = hoje.getFullYear() - nascimento.getFullYear();
      const m = hoje.getMonth() - nascimento.getMonth();
      if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
      }
      return idade;
    },
    mostrarCampoGrauDependencia() {
      return this.idadeUsuario >= 60;
    },
  },
  methods: {
    async buscarMunicipio() {
      this.municipio = this.$store.state.municipio.toLowerCase();
    },
    getUnidades() { 
      this.load = true;
      axios.get("api/dashboard/unidades-interna-externa").then((response) => {
          this.unidades = response.data.data.map((item) => ({
              id: String(item.id),
              value: item.descricao
          }));
      });
    },
    checarPrograma() {
      console.log(this.data);
    },
    getViolacoes() {
      axios.get(`api/dashboard/get/violencias`).then((response) => {
        this.violacoes = response.data;
      });
    },
    getServicos() {
      axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
        this.servicos = response.data;
      });
    },
    getRoles() {
      // Get all settings values
      axios.get("api/dashboard/users/roles").then((response) => {
        if (response.data.data) {
          this.roles = response.data.data.map((elem) => ({
            id: elem.id,
            value: elem.name,
          }));
        }

        // this.roles = response.data.data;
        this.loading = false;
      });
    },
    submitFile(files) {
      this.files = files;
    },
    
    submit() {
      this.loading = true;

      if (!this.data.situacao_rua) {
        this.$bvToast.toast('Informe se a pessoa está em situação de rua.', {
          title: 'Validação',
          variant: 'danger',
          solid: true
        });
        this.loading = false;
        return;
      }

      if (!this.data.grupo_irmaos) {
        this.$bvToast.toast('Informe se é um acolhimento de grupo de irmãos.', {
          title: 'Validação',
          variant: 'danger',
          solid: true
        });
        this.loading = false;
        return;
      }
      
      if (this.data.familia_membros === null || this.data.familia_membros === undefined || this.data.familia_membros === "") {
        this.$bvToast.toast('Selecione se há presença de criança(s) e/ou adolescente(s) na família.', {
          title: 'Validação',
          variant: 'danger',
          solid: true
        });
        this.loading = false;
        return;
      }

      let formData = new FormData();
      for (const i of Object.keys(this.data)) {
        formData.append(i, this.data[i]);
      }

      if (Array.isArray(this.data.familia_membros)) {
        this.data.familia_membros.forEach((item, index) => {
          formData.append(`familia_membros[${index}]`, item);
        });
      }

      if (Array.isArray(this.data.motivo_acolhimento)) {
        this.data.motivo_acolhimento.forEach((item, index) => {
          formData.append(`motivo_acolhimento[${index}]`, item);
        });
      }

      if (Array.isArray(this.data.list_deficiencia)) {
        this.data.list_deficiencia.forEach((item, index) => {
          formData.append(`list_deficiencia[${index}]`, item);
        });
      }

      formData.append("nome_irmaos", JSON.stringify(this.data.nome_irmaos));
      formData.append('deficiencia', this.data.deficiencia ? 1 : 0);
      formData.append('situacao_rua', this.data.situacao_rua ? 1 : 0);
      formData.append('grupo_irmaos', this.data.grupo_irmaos ? 1 : 0);
      formData.append('sexo_id', this.data.sexo_id ? 1 : 0);
      formData.append('deficiencia_requer_apoio', this.data.deficiencia_requer_apoio ? 1 : 0);

      const ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      const url = this.modo === 'editar'
        ? `api/dashboard/acolhimento/solicitacao/vaga/${this.data.id}`
        : `api/dashboard/acolhimento/solicitacao/vaga`;

      const method = this.modo === 'editar' ? 'post' : 'post'; // ou 'put' se a API permitir

      axios[method](url, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      })
        .then((response) => {
          ladda.stop();
          this.loading = false;

          this.$snack.success({
            button: false,
            
            text: response.data.message || 'Solicitação salva com sucesso!'
          });

          this.$bvModal.hide('solicitacao-vagas');

          setTimeout(() => {
            window.location.reload(); // ou emitir evento
          }, 800);
        })
        .catch((error) => {
          ladda.stop();
          this.loading = false;

          const errors = error.response?.data?.errors;
          if (errors) {
            for (let field in errors) {
              this.$snack.error({
                button: false,
                text: errors[field][0]
              });
            }
          } else {
            this.$snack.error({
              button: false,
              text: 'Erro ao enviar a solicitação.'
            });
          }
        });
    }

  }
};
</script>
